/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewProcessPagedResponse } from './CRSFSecReviewProcessPagedResponse';
import {
    CRSFSecReviewProcessPagedResponseFromJSON,
    CRSFSecReviewProcessPagedResponseFromJSONTyped,
    CRSFSecReviewProcessPagedResponseToJSON,
} from './CRSFSecReviewProcessPagedResponse';
import type { CRSFSecReviewProcessShort } from './CRSFSecReviewProcessShort';
import {
    CRSFSecReviewProcessShortFromJSON,
    CRSFSecReviewProcessShortFromJSONTyped,
    CRSFSecReviewProcessShortToJSON,
} from './CRSFSecReviewProcessShort';
import type { CRSFSecReviewProcessShortPagedResponse } from './CRSFSecReviewProcessShortPagedResponse';
import {
    CRSFSecReviewProcessShortPagedResponseFromJSON,
    CRSFSecReviewProcessShortPagedResponseFromJSONTyped,
    CRSFSecReviewProcessShortPagedResponseToJSON,
} from './CRSFSecReviewProcessShortPagedResponse';

/**
 * 
 * @export
 * @interface ResponseListLastListGet1
 */
export interface ResponseListLastListGet1 {
    /**
     * 
     * @type {number}
     * @memberof ResponseListLastListGet1
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseListLastListGet1
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewProcessShort>}
     * @memberof ResponseListLastListGet1
     */
    results?: Array<CRSFSecReviewProcessShort>;
    /**
     * 
     * @type {number}
     * @memberof ResponseListLastListGet1
     */
    total?: number;
}

/**
 * Check if a given object implements the ResponseListLastListGet1 interface.
 */
export function instanceOfResponseListLastListGet1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResponseListLastListGet1FromJSON(json: any): ResponseListLastListGet1 {
    return ResponseListLastListGet1FromJSONTyped(json, false);
}

export function ResponseListLastListGet1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListLastListGet1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewProcessShortFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function ResponseListLastListGet1ToJSON(value?: ResponseListLastListGet1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewProcessShortToJSON)),
        'total': value.total,
    };
}

